export const loyaltyTranslations = {
  ar: {
    title: 'نظام الولاء',
    subtitle: 'إدارة برامج الولاء ونقاط العملاء',
    programSettings: 'إعدادات البرنامج',
    customerPoints: 'نقاط العملاء',
    transactions: 'المعاملات',
    statistics: 'الإحصائيات',
    topCustomers: 'أفضل العملاء',
    noProgram: 'لا يوجد برنامج ولاء نشط',
    createProgram: 'إنشاء برنامج ولاء',
    editProgram: 'تعديل البرنامج',
    programName: 'اسم البرنامج',
    description: 'الوصف',
    pointsPerCurrency: 'النقاط لكل ريال',
    currencyPerPoint: 'قيمة النقطة (ريال)',
    minimumPurchase: 'الحد الأدنى للشراء',
    minimumRedeem: 'الحد الأدنى للاستبدال',
    autoEnroll: 'التسجيل التلقائي',
    pointsExpire: 'انتهاء صلاحية النقاط',
    expirationDays: 'عدد أيام الصلاحية',
    customer: 'العميل',
    currentPoints: 'النقاط الحالية',
    totalEarned: 'إجمالي المكتسب',
    totalRedeemed: 'إجمالي المستخدم',
    totalExpired: 'إجمالي المنتهي',
    tier: 'المستوى',
    type: 'النوع',
    amount: 'المبلغ',
    date: 'التاريخ',
    totalEnrolled: 'إجمالي المسجلين',
    totalActivePoints: 'إجمالي النقاط النشطة',
    totalEarnedAll: 'إجمالي النقاط المكتسبة',
    totalRedeemedAll: 'إجمالي النقاط المستخدمة',
    totalExpiredAll: 'إجمالي النقاط المنتهية',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    saveSuccess: 'تم الحفظ بنجاح',
    saveError: 'فشل الحفظ',
    search: 'بحث...',
    enrollDate: 'تاريخ التسجيل',
    lastActivity: 'آخر نشاط',
    earn: 'كسب',
    redeem: 'استبدال',
    adjust: 'تعديل',
    expire: 'انتهاء',
    refund: 'استرجاع',
    noData: 'لا توجد بيانات',
    viewDetails: 'عرض التفاصيل',
    active: 'نشط',
    inactive: 'غير نشط',
  },
  en: {
    title: 'Loyalty System',
    subtitle: 'Manage loyalty programs and customer points',
    programSettings: 'Program Settings',
    customerPoints: 'Customer Points',
    transactions: 'Transactions',
    statistics: 'Statistics',
    topCustomers: 'Top Customers',
    noProgram: 'No active loyalty program',
    createProgram: 'Create Loyalty Program',
    editProgram: 'Edit Program',
    programName: 'Program Name',
    description: 'Description',
    pointsPerCurrency: 'Points Per Currency',
    currencyPerPoint: 'Currency Per Point',
    minimumPurchase: 'Minimum Purchase Amount',
    minimumRedeem: 'Minimum Points to Redeem',
    autoEnroll: 'Auto Enroll Customers',
    pointsExpire: 'Points Expiration',
    expirationDays: 'Expiration Days',
    customer: 'Customer',
    currentPoints: 'Current Points',
    totalEarned: 'Total Earned',
    totalRedeemed: 'Total Redeemed',
    totalExpired: 'Total Expired',
    tier: 'Tier',
    type: 'Type',
    amount: 'Amount',
    date: 'Date',
    totalEnrolled: 'Total Enrolled',
    totalActivePoints: 'Total Active Points',
    totalEarnedAll: 'Total Points Earned',
    totalRedeemedAll: 'Total Points Redeemed',
    totalExpiredAll: 'Total Points Expired',
    loading: 'Loading...',
    error: 'An error occurred',
    saveSuccess: 'Saved successfully',
    saveError: 'Failed to save',
    search: 'Search...',
    enrollDate: 'Enrollment Date',
    lastActivity: 'Last Activity',
    earn: 'Earn',
    redeem: 'Redeem',
    adjust: 'Adjust',
    expire: 'Expire',
    refund: 'Refund',
    noData: 'No data available',
    viewDetails: 'View Details',
    active: 'Active',
    inactive: 'Inactive',
  },
  fr: {
    title: 'Système de fidélité',
    subtitle: 'Gérer les programmes de fidélité et les points clients',
    programSettings: 'Paramètres du programme',
    customerPoints: 'Points clients',
    transactions: 'Transactions',
    statistics: 'Statistiques',
    topCustomers: 'Meilleurs clients',
    noProgram: 'Aucun programme de fidélité actif',
    createProgram: 'Créer un programme de fidélité',
    editProgram: 'Modifier le programme',
    programName: 'Nom du programme',
    description: 'Description',
    pointsPerCurrency: 'Points par devise',
    currencyPerPoint: 'Valeur du point',
    minimumPurchase: 'Montant minimum d\'achat',
    minimumRedeem: 'Points minimum à échanger',
    autoEnroll: 'Inscription automatique des clients',
    pointsExpire: 'Expiration des points',
    expirationDays: 'Jours d\'expiration',
    customer: 'Client',
    currentPoints: 'Points actuels',
    totalEarned: 'Total gagné',
    totalRedeemed: 'Total utilisé',
    totalExpired: 'Total expiré',
    tier: 'Niveau',
    type: 'Type',
    amount: 'Montant',
    date: 'Date',
    totalEnrolled: 'Total inscrits',
    totalActivePoints: 'Total des points actifs',
    totalEarnedAll: 'Total des points gagnés',
    totalRedeemedAll: 'Total des points utilisés',
    totalExpiredAll: 'Total des points expirés',
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    saveSuccess: 'Enregistré avec succès',
    saveError: 'Échec de l\'enregistrement',
    search: 'Rechercher...',
    enrollDate: 'Date d\'inscription',
    lastActivity: 'Dernière activité',
    earn: 'Gagner',
    redeem: 'Échanger',
    adjust: 'Ajuster',
    expire: 'Expirer',
    refund: 'Rembourser',
    noData: 'Aucune donnée disponible',
    viewDetails: 'Voir les détails',
    active: 'Actif',
    inactive: 'Inactif',
  },
};
